// Model description shown on an order: the one of its main assembly. The fallback (the template's
// on create, the current value on edit) is only used when the main assembly has none.
export const pickModelDescription = (mainAssembly, fallback) => {
    const own = (mainAssembly?.model_description || '').trim();
    return own || fallback || '';
};
